/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Breadcrumbs } from './Breadcrumbs';
import {
    BreadcrumbsFromJSON,
    BreadcrumbsFromJSONTyped,
    BreadcrumbsToJSON,
} from './Breadcrumbs';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { PageTypeConstants } from './PageTypeConstants';
import {
    PageTypeConstantsFromJSON,
    PageTypeConstantsFromJSONTyped,
    PageTypeConstantsToJSON,
} from './PageTypeConstants';
import type { RecentItems } from './RecentItems';
import {
    RecentItemsFromJSON,
    RecentItemsFromJSONTyped,
    RecentItemsToJSON,
} from './RecentItems';
import type { Section } from './Section';
import {
    SectionFromJSON,
    SectionFromJSONTyped,
    SectionToJSON,
} from './Section';
import type { WizardPageInfo } from './WizardPageInfo';
import {
    WizardPageInfoFromJSON,
    WizardPageInfoFromJSONTyped,
    WizardPageInfoToJSON,
} from './WizardPageInfo';

/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * 
     * @type {PageTypeConstants}
     * @memberof Page
     */
    type: PageTypeConstants;
    /**
     * 
     * @type {string}
     * @memberof Page
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof Page
     */
    id: string;
    /**
     * 
     * @type {Breadcrumbs}
     * @memberof Page
     */
    breadcrumbs?: Breadcrumbs;
    /**
     * 
     * @type {Command}
     * @memberof Page
     */
    collapseAllSections?: Command;
    /**
     * Optional list of commands (typically rendered as buttons)
     * @type {Array<Command>}
     * @memberof Page
     */
    commands: Array<Command>;
    /**
     * 
     * @type {string}
     * @memberof Page
     */
    entityAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof Page
     */
    entityQualifiedId?: string;
    /**
     * 
     * @type {Command}
     * @memberof Page
     */
    expandAllSections?: Command;
    /**
     * 
     * @type {RecentItems}
     * @memberof Page
     */
    recentItems?: RecentItems;
    /**
     * 
     * @type {Array<Section>}
     * @memberof Page
     */
    sections: Array<Section>;
    /**
     * 
     * @type {Command}
     * @memberof Page
     */
    triggerDataChanged?: Command;
    /**
     * 
     * @type {WizardPageInfo}
     * @memberof Page
     */
    wizardPageInfo?: WizardPageInfo;
}

/**
 * Check if a given object implements the Page interface.
 */
export function instanceOfPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "commands" in value;
    isInstance = isInstance && "sections" in value;

    return isInstance;
}

export function PageFromJSON(json: any): Page {
    return PageFromJSONTyped(json, false);
}

export function PageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Page {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PageTypeConstantsFromJSON(json['type']),
        'label': json['label'],
        'id': json['id'],
        'breadcrumbs': !exists(json, 'breadcrumbs') ? undefined : BreadcrumbsFromJSON(json['breadcrumbs']),
        'collapseAllSections': !exists(json, 'collapseAllSections') ? undefined : CommandFromJSON(json['collapseAllSections']),
        'commands': ((json['commands'] as Array<any>).map(CommandFromJSON)),
        'entityAlias': !exists(json, 'entityAlias') ? undefined : json['entityAlias'],
        'entityQualifiedId': !exists(json, 'entityQualifiedId') ? undefined : json['entityQualifiedId'],
        'expandAllSections': !exists(json, 'expandAllSections') ? undefined : CommandFromJSON(json['expandAllSections']),
        'recentItems': !exists(json, 'recentItems') ? undefined : RecentItemsFromJSON(json['recentItems']),
        'sections': ((json['sections'] as Array<any>).map(SectionFromJSON)),
        'triggerDataChanged': !exists(json, 'triggerDataChanged') ? undefined : CommandFromJSON(json['triggerDataChanged']),
        'wizardPageInfo': !exists(json, 'wizardPageInfo') ? undefined : WizardPageInfoFromJSON(json['wizardPageInfo']),
    };
}

export function PageToJSON(value?: Page | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PageTypeConstantsToJSON(value.type),
        'label': value.label,
        'id': value.id,
        'breadcrumbs': BreadcrumbsToJSON(value.breadcrumbs),
        'collapseAllSections': CommandToJSON(value.collapseAllSections),
        'commands': ((value.commands as Array<any>).map(CommandToJSON)),
        'entityAlias': value.entityAlias,
        'entityQualifiedId': value.entityQualifiedId,
        'expandAllSections': CommandToJSON(value.expandAllSections),
        'recentItems': RecentItemsToJSON(value.recentItems),
        'sections': ((value.sections as Array<any>).map(SectionToJSON)),
        'triggerDataChanged': CommandToJSON(value.triggerDataChanged),
        'wizardPageInfo': WizardPageInfoToJSON(value.wizardPageInfo),
    };
}

